import { ClockIcon } from '@root/src/assets/images';
import { ReactElement, useEffect, useState } from 'react';
import Tag from '@designSystem/tags';
import { timeToColor, timeToLabel } from './ordersTable/utils';
import Lang from '@lang/en';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';

type TimerTagI = {
  timerEnd: number;
  withLabel?: boolean;
};

const TimerTag = ({ timerEnd, withLabel }: TimerTagI): ReactElement => {
  const clockIcon = <ClockIcon />;
  const [label, setLabel] = useState(timeToLabel(timerEnd, withLabel));
  const [color, setColor] = useState(timeToColor(timerEnd));
  const { href } = window.location;
  const orderUrlRegex = /\/order\/[0-9]+/g;
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
      return;
    }

    if (
      (label === Lang.healthCheckTestPerformedReadyText ||
        label === Lang.healthCheckTestPerformedExpiredText) &&
      href.match(orderUrlRegex)
    ) {
      showNotification({
        text: Lang.healthCheckTimerFinishedNotification,
        type: 'success',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  useEffect(() => {
    const timer = setInterval(() => {
      setLabel(timeToLabel(timerEnd, withLabel));
      setColor(timeToColor(timerEnd));
    }, 1000);
    return () => clearTimeout(timer);
  }, [label, timerEnd, withLabel]);

  return (
    <Tag
      dataTestId="timerTag"
      type="normal"
      label={label}
      color={color}
      icon={clockIcon}
    />
  );
};

export default TimerTag;
